import PickerRoot, { PickerRootProps as PickerProps, PickerValue } from "./picker";
import PickerColumn from "./picker-column";
import PickerItem from "./picker-item";

export type { PickerProps, PickerValue };

const Picker = PickerRoot as typeof PickerRoot & {
  Column: typeof PickerColumn;
  Item: typeof PickerItem;
};

Picker.Column = PickerColumn;
Picker.Item = PickerItem;

export default Picker;
